'use strict';

module.exports = function(departments, $scope, $state, formsPreview, tasksPreview) {
    var _this = this;
    this.department = departments.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];
    
    this.department.forms = formsPreview;
    this.tasksPreview = tasksPreview;

    this.notArchivedFilter = function(form) {
        return !form.archived;
    };
};
